import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Microphone from './icon-microphone.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    const color = validProps.color || validProps.fill || colors.black;

    return <Microphone {...validProps} color={color} />;
}
SvgComponent.iconName = 'microphone';

export const MicrophoneIcon = svgIconWrapper(SvgComponent);
